
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/api-reference",
      function () {
        return require("private-next-pages/api-reference.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/api-reference"])
      });
    }
  